import { render } from "./top-content.vue?vue&type=template&id=922a1ffc&scoped=true"
import script from "./top-content.vue?vue&type=script&lang=js"
export * from "./top-content.vue?vue&type=script&lang=js"

import "./top-content.vue?vue&type=style&index=0&id=922a1ffc&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-922a1ffc"]])

export default __exports__